import { useState } from "react";
import { useVendorApi } from "@/hooks/apiHooks/useVendorApi";
import { Button, Label } from "@common/index";
import { Input } from "@common/Form/Input";
import type { VendorResponse } from "@models/vendor";
import { ComponentColor } from "@common/types";

export const Vendor = () => {
    const { createVendor, getVendors } = useVendorApi();
    const [name, setName] = useState("");
    const [vendors, setVendors] = useState<VendorResponse[]>([]);

    const handleCreate = async () => {
        if (!name.trim()) return;
        await createVendor({ name: name.trim() });
        setName("");
    };

    const handleGetVendors = async () => {
        const data = await getVendors();
        setVendors(data);
    };

    return (
        <div className="p-6 bg-white rounded-lg shadow-md max-w-4xl">
            <h2 className="text-xl font-bold mb-4">Vendors</h2>

            <div className="space-y-4 mb-6">
                <div>
                    <Label>Vendor Name *</Label>
                    <Input
                        name="name"
                        type="text"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        placeholder="Enter vendor name"
                    />
                </div>

                <div className="flex gap-2">
                    <Button onClick={handleGetVendors} color={ComponentColor.Secondary}>
                        Get All Vendors
                    </Button>
                    <Button onClick={handleCreate} color={ComponentColor.Primary} disabled={!name.trim()}>
                        Create Vendor
                    </Button>
                </div>
            </div>

            {vendors.length > 0 && (
                <div className="mt-6 border-t pt-4">
                    <h3 className="text-lg font-semibold mb-3">Vendors ({vendors.length}):</h3>
                    <table className="table table-sm w-full">
                        <thead>
                            <tr>
                                <th>ID</th>
                                <th>Name</th>
                                <th>Active</th>
                            </tr>
                        </thead>
                        <tbody>
                            {vendors.map((v) => (
                                <tr key={v.id}>
                                    <td>{v.id}</td>
                                    <td>{v.name}</td>
                                    <td>{v.isActive ? "✓" : "✗"}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
};
